import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
var Loading = function Loading(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Loading...' : _ref$text;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-75 container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loading-panel"
  }, /*#__PURE__*/React.createElement("p", {
    className: "lead",
    style: {
      fontSize: '20px'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: text
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-duotone fa-solid fa-spinner-third",
    spin: true,
    style: {
      color: '#027e6f'
    }
  })))));
};
export default Loading;